import { useRoutes } from "react-router-dom";
import { appRoutes } from "./routes";

const Navigator = () => {
    
    const appRouter = useRoutes(appRoutes);

    const render = () => appRouter;

    return render()
};

export default Navigator;
